import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bets-list" }
const _hoisted_2 = { class: "bs-container" }
const _hoisted_3 = { class: "bs-row justify-content-center" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BetsCarousel = _resolveComponent("BetsCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.syndicatesClosestToFilling && _ctx.syndicatesClosestToFilling.length)
      ? (_openBlock(), _createBlock(_component_BetsCarousel, {
          key: 0,
          title: "Nejblíže k naplnění",
          data: _ctx.syndicatesClosestToFilling
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (_ctx.syndicatesBiggest && _ctx.syndicatesBiggest.length)
      ? (_openBlock(), _createBlock(_component_BetsCarousel, {
          key: 1,
          title: "Největší sázenky",
          data: _ctx.syndicatesBiggest
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (_ctx.syndicatesClosestDraw && _ctx.syndicatesClosestDraw.length)
      ? (_openBlock(), _createBlock(_component_BetsCarousel, {
          key: 2,
          title: "Na nejbližší slosování",
          data: _ctx.syndicatesClosestDraw
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "btn btn-primary",
          href: "trziste-sazenek",
          innerHTML: _ctx.syndicatesCountLabel
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}